import { render, staticRenderFns } from "./membership-edit.vue?vue&type=template&id=68d71774"
import script from "./membership-edit.vue?vue&type=script&lang=js"
export * from "./membership-edit.vue?vue&type=script&lang=js"
import style0 from "./membership-edit.vue?vue&type=style&index=0&id=68d71774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports